<template>
    <div class="grid grid-cols-1 lg:grid-cols-detail m-4 md:mx-8 md:mt-16 gap-8">
        <section class="w-full rounded">
            <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
                <h2>{{ $t("lang.msg.agentData") }}</h2>
            </div>
            <form class="bg-white p-4 space-y-4 rounded-b">
                <InputWrapper :label="$t('lang.msg.nameAndLastname')" content="input" block>
                    <InputText v-model="newItem.factoryAgentName" :name="$t('lang.fields.name')" font-semibold/>
                </InputWrapper>
                <InputWrapper
                    :label="$t('lang.msg.factory')"
                    content="input"
                    block
                >
                    <multiselect
                        v-model="newItem.factories"
                        :options="factories"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="true"
                        :preserve-search="true"
                        :taggable="true"
                        tag-placeholder="Escriba para añadir una fábrica"
                        placeholder="Escriba para buscar fábricas"
                        label="factoryName"
                        track-by="idFactory"
                        select-label="Pulse enter para seleccionar"
                        deselect-label="Pulse enter para eliminar"
                        @select="storeFactory"
                        @remove="removeFactory"
                    />
                </InputWrapper>
                <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
                    <InputText v-model="newItem.factoryAgentPhone" :name="$t('lang.fields.phone')"/>
                </InputWrapper>
                <InputWrapper :label="$t('lang.msg.origin')" content="input" block>
                    <InputText v-model="newItem.factoryAgentOrigen" :name="$t('lang.msg.origin')"/>
                </InputWrapper>
                <InputWrapper :label="$t('lang.msg.paymentMethod')" content="input" block>
                    <Select
                        id="idFormaPago"
                        :data="paymentMethods"
                        :track-by="getLangLabel('pagoNombre')"
                        v-model.number="newItem.idFormaPago"
                    />
                </InputWrapper>
                <AdminToggleButton v-model="newItem.active"/>
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-primario hover:bg-primario text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
              @click="addOrEditItem(`api/FactoryAgents/Add`, `api/FactoryAgents/Update`)"
          >{{ newItem.idFactoryAgent == undefined ? $t('lang.msg.add') : $t('lang.msg.update') }}</button>
        </span>
            </form>
        </section>

        <div class="flex flex-col w-full space-y-8" v-if="newItem.idFactoryAgent">
            <section>
                <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
                    <h2>{{ $t("lang.msg.contactPersons") }}</h2>
                </div>
                <div class="bg-white px-4 pb-2 rounded-b">
                    <div
                        v-for="(item, index) in contacts"
                        :key="`item_${index}`"
                        class="py-2 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-contacts gap-2 items-end"
                    >
                        <InputWrapper :label="$t('lang.fields.name')" content="input" block>
                            <InputText v-model="item.contactName" :name="$t('lang.fields.name')"/>
                        </InputWrapper>
                        <InputWrapper :label="$t('lang.fields.email')" content="input" block>
                            <InputText v-model="item.email" :name="$t('lang.fields.email')"/>
                        </InputWrapper>
                        <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
                            <InputText v-model="item.phone" :name="$t('lang.fields.phone')"/>
                        </InputWrapper>
                        <InputWrapper :label="$t('lang.fields.charge')" content="input" block>
                            <InputText v-model="item.cargo" :name="$t('lang.fields.charge')"/>
                        </InputWrapper>
                        <div class="flex justify-between">
                            <div class="flex space-x-2">
                                <div class="flex space-x-2" v-if="contacts.length > 1 && item.idContactPerson">
                                    <ButtonRounded @action="removeContact(index)" color="red">
                                        <IconRemove/>
                                    </ButtonRounded>

                                    <ButtonRounded @action="updateContact(item)" color="green">
                                        <IconUpdate/>
                                    </ButtonRounded>
                                </div>
                                <ButtonRounded
                                    v-if="index == contacts.length - 1"
                                    @action="addNewContact(item)"
                                    color="blue"
                                >
                                    <IconAdd/>
                                </ButtonRounded>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import UtilsMixin from "@/components/mixins/UtilsMixin";
import AdminMixin from "@/components/mixins/AdminMixin";
import Multiselect from "vue-multiselect";

export default {
    name: "AgentDetail",
    mixins: [UtilsMixin, AdminMixin],
    components: {Multiselect},
    data() {
        return {
            idAgent: 0,
            paymentMethods: [],
            newItem: {
                factoryAgentName: '',
                factories: []
            },
            contacts: [],
            factories: [],
            headers: {
                idFactoryAgent: "#",
                factoryAgentName: `${this.$t("lang.msg.nameAndLastname")} `,
                factoryAgentPhone: this.$t("lang.fields.phone"),
                factoryAgentOrigen: this.$t("lang.msg.origin"),
                active: {
                    name: this.$t("lang.msg.active"),
                    type: Boolean
                }
            }

        }
    },
    created() {
        if (this.$route.params.idFactoryAgent !== 'newAgent') {
            this.idFactoryAgent = parseInt(this.$route.params.idFactoryAgent);
            this.isEditing = true;

            // Set params to fetch the initial data.
            this.params = {idFactoryAgent: this.idFactoryAgent};
            this.fetchAgentFactories(this.idFactoryAgent);
            this.fetchFactoryContacts();
            this.fetchAgents();
        }
        this.fetchFactories();
        this.fetchPaymentMethods();

    },
    methods: {
        fetchAgentFactories(id) {
            this.$axios.post(`api/FactoryAgents/GetAllFactory`, {
                idFactoryAgent: id
            }).then((response) => {
                this.$set(this.newItem, 'factories', response.data);
            });
        },
        fetchFactories() {
            this.$axios.get("api/DocumentCertificats/ComboFactory").then((response) => {
                this.factories = response.data;
            });
        },
        fetchAgents() {
            if (this.idFactoryAgent) {
                this.$axios.get(`api/FactoryAgents/GetFactoryAgent`, this.params).then((response) => {
                    this.newItem = response.data.filter(element => {
                        return element.idFactoryAgent == this.idFactoryAgent;
                    })[0];
                });
            }
        },
        fetchFactoryContacts() {
            this.$axios.post("api/ContactPersons/PostSearchAgent", this.params).then((response) => {
                // At least 1 contact exist in the array.
                response.data.push({});

                this.contacts = response.data;
            });
        },
        fetchPaymentMethods() {
            this.$axios.get(`api/FormaPagoes/GetAll`).then((response) => {
                this.paymentMethods = this.getActive(response.data, 'active');
            });
        },
        storeFactory(item) {
            this.$axios.post(`api/FactoryAgents/AddFactory`, {
                idFactory: item.idFactory,
                idFactoryAgent: this.newItem.idFactoryAgent
            });
        },
        removeFactory(item) {
            this.$axios.post(`api/FactoryAgents/Delete`, item);
        },
        addOrEditItem(addURL, editUrl) {
            let url = "";
            let message = "";

            if (this.isEditing) {
                message = "Registro actualizado con éxito";
                url = editUrl;
            } else {
                message = "Registro añadido con éxito";
                url = addURL;
            }

            this.$axios.post(url, this.newItem).then(() => {
                this.fetchAgents();
                this.fetchAgentFactories(this.newItem.idFactoryAgent);
                this.openAlert('success', message, null);
            });
        },
        contactIsValid(contact) {
            return contact.contactName && contact.email && contact.phone && contact.cargo;
        },
        addNewContact(contact) {
            if (this.contactIsValid(contact)) {
                // Append the idFactoryAgent to the contact.
                contact.idFactoryAgent = this.idFactoryAgent

                this.$axios.post(`api/ContactPersons/Add`, contact).then(() => {
                    this.openAlert('success', 'Contacto añadido con éxito', null);
                    this.fetchFactoryContacts(this.params);
                    this.contacts.push({});
                });
            } else {
                this.openAlert('info', 'Rellene correctamente el formulario', null);
            }
        },
        updateContact(contact) {
            this.$axios.post(`api/ContactPersons/Update`, contact).then(() => {
                this.openAlert('success', 'Contacto actualizado', null);
            });
        },
        removeContact(index) {
            let contact = this.contacts[index];

            this.$axios.post(`api/ContactPersons/Delete`, contact).then(() => {
                this.openAlert('success', 'Contacto eliminado', null);
            });

            this.contacts.splice(index, 1);
        }
    }
}
</script>

<style scoped>

</style>
